import React from 'react';
import {AutoSizer, List} from "react-virtualized";
import Utils from "../../common/Utils";
import ProfileAvatar from "../ProfileAvatar/ProfileAvatar";
import PropTypes from 'prop-types';
import _ from 'lodash';

const PaginatedView  = (props) => {

    const data = props.data;
    return <div style={props.style}>
    <AutoSizer disableHeight>

        {({width}) =>
             <List
                 height={data.length === 0 ? props.noRowsHeight : props.height}
                 rowHeight={props.rowHeight}
                 rowCount={data.length}
                 overscanRowCount={10}
                 rowRenderer={function ({index, isScrolling, key, style}) {

                     const item = data[index];
                     return <div className={props.rowStyle} key={key} style={style} onClick={() => {

                         if(props.onItemClick)
                             props.onItemClick(item,index);

                     }}>
                         {props.renderItem(item,index)}
                     </div>
                 }}
                 noRowsRenderer={() => _.isString(props.emptyMessage) ? <p className="text-center">{props.emptyMessage}</p> : props.emptyMessage }
                 width={width}>
            </List>
        }

    </AutoSizer>
    </div>

};

const ListItemView = (props) => {

    const iconSize = 36;
    return <div className={"row " + (props.separator ? "row-separator" : "") + (props.className ? ` ${props.className}` : "")} style={props.style} onClick={props.onClick}>
        <div className="col-md-2 text-center">
            {props.iconRender ? props.iconRender({ size: iconSize }) : props.avatarName && <ProfileAvatar media={props.media} showFullscreen={false}  name={Utils.formatAvatarName(props.avatarName)}  round={true} size={iconSize} />}
        </div>
        <div className="col-md-10">
            <div>{props.title}</div>
            <div>{props.subheader}</div>
        </div>
    </div>
};

ListItemView.propTypes = {
    avatarName: PropTypes.string,
    media: PropTypes.any,
    iconRender: PropTypes.func,
    separator: PropTypes.bool,
    title: PropTypes.any,
    subheader: PropTypes.any,
    style: PropTypes.object,
    className: PropTypes.string,
    onClick: PropTypes.func
};

PaginatedView.propTypes = {
    emptyMessage: PropTypes.any,
    data: PropTypes.any,
    height: PropTypes.number,
    noRowsHeight: PropTypes.number,
    rowHeight: PropTypes.any,
    rowStyle: PropTypes.any,
    renderItem: PropTypes.func,
    onItemClick: PropTypes.func,
    style: PropTypes.object,
};

PaginatedView.defaultProps = {
    height: 270,
    headerHeight: 30,
    rowHeight: 60,
    noRowsHeight: 50
};

export {
    PaginatedView,
    ListItemView
};


// WEBPACK FOOTER //
// ./src/components/PaginatedView/PaginatedView.js